<template>
  <div>
    <el-table
      :data="keywords.data"
      :default-sort="{ prop: order_column, order: order_type }"
      class="w100"
      stripe
      v-loading="loading"
    >
      <el-table-column label="Label" prop="label"></el-table-column>
      <el-table-column label="Keywords" prop="keywords"></el-table-column>
      <el-table-column label="Actions" align="right" width="100%">
        <template slot-scope="props">
          <el-tooltip content="Delete" placement="top">
            <el-button
                type="danger"
                circle
                size="small"
                icon="el-icon-delete"
                @click="removeDialog(props.row.id)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('youtubeKeywords', [
      'keywords',
      'loading',
      'order_column',
      'order_type',
      'page_size'
    ])
  },

  methods: {
    ...mapMutations('youtubeKeywords', ['setPage', 'setDialog', 'setSelectedKeyword']),
    ...mapActions('youtubeKeywords', ['read', 'delete']),
    currentChange(currentPage) {
      this.setPage(currentPage)
      this.read()
    },
    removeDialog(id) {
      this.$confirm(
          'You will remove this keyword. Continue?',
          'Warning',
          {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
      )
          .then(() => {
            this.delete(id)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: 'Unpublish cancelled'
            })
          })
    }
  },

  created() {
    this.read()
  }
}
</script>
]
